import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ScheduledGroceryInput } from '@/models/scheduledGrocery';

export const updateScheduledGrocery = async (scheduledGrocery: ScheduledGroceryInput) => {
  const response = await mutationExecute({
    variables: {
      scheduledGrocery,
    },
    mutation: graphql(`
      mutation UpdateScheduledGrocery($scheduledGrocery: ScheduledGroceryInputType!) {
        updateScheduledGrocery(scheduledGrocery: $scheduledGrocery) {
          id
        }
      }
    `),
  });

  return response.data?.updateScheduledGrocery;
};
